#import "../../../../core/schema/fragments/ImageFull.graphql"

mutation (
  $url: String!
) {
  uploadImageFromUrl(
    url: $url
  ) {
    success
    image {
      ...ImageFull
    }
    errorMessage
  }
}
